export default __webpack_public_path__ + "static/media/img-proj-urbancrown.ea8dfc25.png";